import React, { useState } from 'react';
import { Upload, Row, Alert } from 'antd';
import { LoadingOutlined, UploadOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { RcFile } from 'antd/lib/upload/interface';
import { v4 as uuidv4 } from 'uuid';
import { IImageUploaderImageData } from '../../ImageUploader/DefaultState';
import { usePlatStageContext } from '@mono/use-plat-stage';

export interface IFormImageUpload {
	onChange: ({ url, size, dateUploaded, altText, type }: IImageUploaderImageData) => void;
	altText: string;
	imageUrl: string;
	imageUpload: (imgData: any) => any;
}

const ImageUploaderStyle = styled.div`
	width: 100%;
	.static-image-uploader,
	.static-image-uploader .ant-upload {
		width: 100%;
	}
	.static-image-uploader img {
		width: 50% !important;
	}
	p {
		text-align: center;
	}
`;

const getBase64 = (blobUrl: string) => {
	return new Promise(async (resolve, reject) => {
		const blobResponse = await fetch(blobUrl);
		const blob = await blobResponse.blob();
		var reader = new FileReader();
		reader.readAsDataURL(blob);
		reader.onload = () => {
			resolve(reader.result);
		};
		reader.onerror = (error) => {
			reject(error);
		};
	});
};

const FormImageUpload = ({ onChange, altText, imageUrl, imageUpload }: IFormImageUpload) => {
	const [isLoading, setIsLoading] = useState(false);
	const [isFileSizeOrTypeError, setIsFileSizeOrTypeError] = useState(false);
	const [errorMessage, setErrorMessage] = useState('You can only upload JPG/PNG/GIF file!');
	const { stage } = usePlatStageContext();

	const uploadButton = (
		<div style={{ width: '100%' }}>
			{isLoading && <LoadingOutlined style={{ fontSize: 20 }} />}
			{!isLoading && <UploadOutlined style={{ fontSize: 20 }} />}
			<div className='ant-upload-text'>
				<p>Add image here</p>
				{isFileSizeOrTypeError && <Alert type='error' message={errorMessage} />}
			</div>
		</div>
	);

	const beforeUpload = (file: RcFile) => {
		const isJpgOrPngOrGif = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif';
		if (!isJpgOrPngOrGif) {
			setIsFileSizeOrTypeError(true);
			setErrorMessage('You can only upload JPG/PNG/GIF file!');
			setIsLoading(false);
		}
		const isLt5M = file.size / 5120 / 5120 <= 5;
		if (!isLt5M) {
			setIsFileSizeOrTypeError(true);
			setErrorMessage('Image must smaller than or equal 5MB!');
			setIsLoading(false);
		}
		return isJpgOrPngOrGif && isLt5M;
	};

	return (
		<div style={{ gridColumn: '1/6' }}>
			<Row style={{ width: '100%' }}>
				<ImageUploaderStyle>
					<Upload
						style={{ width: '100%' }}
						name={uuidv4()}
						listType='picture-card'
						className='static-image-uploader'
						showUploadList={false}
						beforeUpload={beforeUpload}
						multiple={false}
						customRequest={(customRequestOptions) => {
							;(async() => {
								const { file, onSuccess, onError } = customRequestOptions;

								setIsLoading(true);
								const typedFile = file as RcFile
								console.log({typedFile, onSuccess, onError})

								try {
									const blobUrl = URL.createObjectURL(file);
									const imageBinary = await getBase64(blobUrl);
									const response = await imageUpload({ imageBinary, blobUrl, stage });
									const {  link } = response;
									
									onChange({
										url: link,
										size: typedFile.size,
										altText: typedFile.name,
										type: typedFile.type,
									});
									if(!onSuccess) return;


									onSuccess({ status: 'ok' });
									setIsLoading(false);
								} catch (error) {
									console.error(`Error uploading image: ${error}`);
									if(!onError) return;
									onError(error);
								}
							})()
						}}
					>
						{imageUrl && !isLoading ? <img src={imageUrl} alt={altText} style={{ width: '100%' }} /> : uploadButton}
					</Upload>
					<p>
						Drag and drop an image above, or select to browse.
						<br />
						Maximum file size 5 MB
					</p>
				</ImageUploaderStyle>
			</Row>
		</div>
	);
};

export default FormImageUpload;
